<template>
  <!-- <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false"> -->
  <v-card class="bigbox" elevation="0">
    <v-card-text
      :class="Array.isArray(treeList) && treeList.length >= 0 ? 'pa-0' : 'pa-8'"
      v-if="Array.isArray(allList) && allList.length > 0"
    >
    <v-row>
        <v-col cols="12" sm="6">
          <mrc_ess_prompt
            :label="$t('label_staff_property_group_name')"
            :disabled="readonly"
            @getData="change"
            v-model="property_master_uuid"
            :obj="sys_property_group"
          >
          </mrc_ess_prompt>
        </v-col>
      </v-row>
      <v-treeview
        dense
        selected-color="primary"
        style="
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
          border-radius: 4px;
        "
        :items="allList"
        item-disabled="disabled"
      >
        <template v-slot:label="{ item }">
          {{ INT(item[itemText]) }}
        </template>
        <template v-slot:append="{ item }">
          <div class="rowbox">
            <span v-if="$store.state.uuid">
              <span v-if="!item.prompt_name">
                {{ item.value }}
              </span>
              <mrc_ess_prompt
                v-if="item.prompt_name"
                view
                :chips="false"
                v-model="item.value"
                :obj="{ prompt_name: item.prompt_name }"
              >
              </mrc_ess_prompt>
            </span>
            <span v-else>
              <span v-if="!item.prompt_name">
                {{ item.property_list | getvalue }}
              </span>
              <mrc_ess_prompt
                v-if="item.prompt_name"
                view
                :chips="false"
                :prompt="getvalueView(item.property_list)"
                :obj="{ prompt_name: item.prompt_name }"
              >
              </mrc_ess_prompt>
            </span>
            <v-btn icon>
              <v-icon
                class="material-icons"
                @click="item.disabled ? '' : addproperty(item)"
                >{{ !readonly ? "edit" : "visibility" }}</v-icon
              >
            </v-btn>
          </div>
        </template>
      </v-treeview>
      <mrc_ess_myDialog
        :isopen="dialog"
        width="680"
        title="Staff Property Name"
        :disabled="!readonly"
        @cancel="close"
        :loading="loading"
        @success="save"
      >
        <v-row>
          <v-col cols="12">
            <mrc_ess_input
              :value="INT(name)"
              :disabled="true"
              label="Property Name"
            ></mrc_ess_input>
          </v-col>
          <v-col cols="12" class="d-flex flex-row-reverse pa-0">
            <!-- <span v-if="!readonly"
                    class="d-flex mr-5">
                <span style="color:#0F46C1;line-height:34px;font-size:16px">
                  {{ $t('label_new_value_added') }}
                </span>
                <v-btn icon
                       @click="addValue">
                  <v-icon class="material-icons"
                          style="color:#0F46C1;font-size:25px">add</v-icon>
                </v-btn>
              </span> -->
            <mrc_ess_textAddBtn
              :text="$t('label_new_value_added')"
              v-if="!readonly"
              @click="addValue"
            ></mrc_ess_textAddBtn>
          </v-col>
        </v-row>
        <v-form ref="forms">
          <!-- 视图上的新增 -->
          <v-row v-for="(item, index) in viewList" :key="index + item">
            <v-col cols="5.5">
              <mrc_ess_datePicker
                :min="$moment(new Date())"
                :disabled="readonly"
                @getTime="getTime"
                :rules="[(v) => !!v || $t('verify_Required')]"
                :allowedDates="limitedTime"
                :label="$t('label_effective_start_date')"
                v-model="item.effective_utc_datetime"
              >
              </mrc_ess_datePicker>
            </v-col>
            <v-col cols="5.5">
              <mrc_ess_input
                v-model="item.value"
                v-if="!item.prompt_name"
                :rules="[(v) => !!v || $t('verify_Required')]"
                :label="$t('label_value') + '*'"
              >
              </mrc_ess_input>
              <mrc_ess_prompt
                v-model="item.value"
                :chips="false"
                :label="$t('label_value') + '*'"
                :rules="$t('verify_Required')"
                v-if="item.prompt_name"
                :obj="{ prompt_name: item.prompt_name }"
              >
              </mrc_ess_prompt>
            </v-col>
            <v-col cols="1" class="d-flex justify-center align-center">
              <v-btn icon>
                <v-icon
                  @click="deleteItemView(item, index)"
                  class="material-icons"
                  >delete</v-icon
                >
              </v-btn>
            </v-col>
          </v-row>
          <!-- 后端的数据显示 -->
          <v-row v-for="(item, index) in list" :key="index">
            <template
              v-if="
                item['~type~'] != 'del' && (readonly ? item.value != '' : true)
              "
            >
              <v-col cols="5.5">
                <mrc_ess_datePicker
                  :disabled="readonly"
                  :min="$moment(new Date())"
                  @getTime="getTime"
                  :rules="[(v) => !!v || $t('verify_Required')]"
                  :allowedDates="limitedTime"
                  :disabledTwo="
                    item.effective_utc_datetime &&
                    (new Date(item.effective_utc_datetime).valueOf() <
                      compareTimeValue ||
                      new Date(item.effective_utc_datetime).valueOf() <
                        new Date().valueOf())
                  "
                  :label="$t('label_effective_start_date')"
                  v-model="item.effective_utc_datetime"
                ></mrc_ess_datePicker>
              </v-col>
              <v-col cols="5.5">
                <mrc_ess_input
                  v-model="item.value"
                  :readonly="readonly"
                  v-if="!item.prompt_name"
                  :rules="[(v) => !!v || $t('verify_Required')]"
                  :disabled="
                    item.effective_utc_datetime &&
                    new Date(item.effective_utc_datetime).valueOf() <
                      compareTimeValue
                  "
                  :label="$t('label_value') + '*'"
                >
                </mrc_ess_input>
                <mrc_ess_prompt
                  v-model="item.value"
                  :disabled="readonly"
                  :disabledTwo="
                    item.effective_utc_datetime &&
                    new Date(item.effective_utc_datetime).valueOf() <
                      compareTimeValue
                  "
                  :chips="false"
                  :label="$t('label_value') + '*'"
                  :rules="$t('verify_Required')"
                  v-if="item.prompt_name"
                  :obj="{ prompt_name: item.prompt_name }"
                >
                </mrc_ess_prompt>
              </v-col>
              <v-col
                cols="1"
                v-if="!readonly"
                class="d-flex justify-center align-center"
              >
                <v-btn
                  icon
                  v-if="
                    !(
                      new Date(item.effective_utc_datetime).valueOf() <
                      compareTimeValue
                    )
                  "
                >
                  <v-icon
                    v-show="item.status != 0"
                    @click="deleteItem(item, index)"
                    class="material-icons"
                    >delete</v-icon
                  >
                </v-btn>
              </v-col>
              <v-col cols="1" v-else class="d-flex justify-center"> </v-col>
            </template>
          </v-row>
        </v-form>
      </mrc_ess_myDialog>
    </v-card-text>
    <mrc_ess_submitBtn
      @success="success"
      v-if="!readonly"
      @cancel="cancel"
      :hideSuccess="Boolean($store.state.uuid)"
      :cancelText="
        !$store.state.uuid ? $t('label_The_previous_step') : $t('label_cancel')
      "
    >
    </mrc_ess_submitBtn>
  </v-card>
  <!-- </mrc_ess_skeleton_loader> -->
</template>

<script>
import {
  getStaffPropertyGroupDetail,
  getPropertyGroupDetail,
  deleteStaffPropertyGroup,
  updateStaffPropertyGroup,
  addStaffPropertyGroup,
  getAddList,
} from "@/service/api/staffPropertyGroup.js";
import {
  getpropertydetail,
  getpropertyupdate,
  getpropertyonedetail,
} from "@/service/api/staffmsg.js";
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    itemText: {
      type: String,
      default: "staff_property_master_name",
    },
    treeList: {
      type: Array,
    },
    groupId:{type: String,default:null}
  },
  data() {
    return {
      property_master_uuid: null,
      loading:false,
      skeletonloading: true,
      items: [],
      title: "",
      dialog: false,
      mrbase_sys_staff_property_group: {},
      allList: [], //所有属性
      list: [], //Staff Property Group值属性详情
      viewList: [],
      name: "",
      num: 0,
      limitedTime: [],
      data_type: "",
      prompt_name: "",
      staff_property_master_code: "",
      staff_property_master_uuid: "",
      isViewInput: false,
      compareTimeValue: null, //最接近得时间值
      ViewInput: {},
      date: "",
      addUpdateStatus: true, //员工新增还是修改
    };
  },
  created() {
    this.property_master_uuid=this.groupId||null
  },
  async mounted() {
    if (this.treeList && this.treeList.length >= 0) {
      this.skeletonloading = false;
    }
    this.date = Date.parse(new Date());
    if (this.$store.state.uuid) {
      await this.getdetail();
    } else {
      // await this.addgetList()
    }
  },
  methods: {
    getTime() {
      this.limitedTime = [];
      [...this.viewList, ...this.list].forEach((item) => {
        if (
          item.effective_utc_datetime == "" ||
          item.effective_utc_datetime == null
        )
          return;
        this.limitedTime.push(item.effective_utc_datetime);
      });
    },
    async change(e) {
      this.$emit('changeGroup',e)
    },

    async addgetList() {
      const res = await getAddList();
      if (res.code == 200) {
        this.addProperty_list(res.data);
        this.allList = res.data;
        this.addDisabled(this.allList, false);
      }
    },
    async getdetail() {
      //获取整个列表
      this.skeletonloading = true;
      if (this.treeList && this.treeList.length >= 0) {
        this.allList = this.treeList;

        this.addDisabledUpdate(this.allList, false); //加禁用属性
      } else {
        const res = await getpropertydetail({
          //获取树  员工信息
          user_id: this.$store.state.detailuuid,
          staff_uuid: this.$store.state.uuid,
        });
        if (res.code == 200) {
          this.allList = res.data.mrbase_sys_staff_property;
          // console.log(res.data, 'res.data');
          this.addDisabledUpdate(this.allList, false); //加禁用属性
        }
      }
      this.skeletonloading = false;
    },
    async addproperty(item) {
      //获取单个行详情
      this.dialog = true;
      this.limitedTime = [];
      this.viewList = [];
      this.list = [];
      let res = null;
      if (this.treeList && this.treeList.length >= 0) {
        res = await getPropertyGroupDetail({
          staff_property_group_uuid: this.$store.state.uuid,
          staff_property_master_uuid: item.staff_property_master_uuid,
        });
      } else {
        res = await getpropertyonedetail({
          staff_uuid: this.$store.state.detailuuid,
          staff_property_master_uuid: item.staff_property_master_uuid,
        });
      }
      if (res.code == 200) {
        this.name = item.staff_property_master_name;
        this.data_type = item.data_type;
        this.prompt_name = item.prompt_name;
        this.staff_property_master_code = item.staff_property_master_code;
        this.staff_property_master_uuid = item.staff_property_master_uuid;
        this.staff_uuid = this.$store.state.detailuuid;
        res.data.sort(this.sortBy("effective_utc_datetime"));
        this.compareTimeValue = this.getvalueView(
          res.data,
          "effective_utc_datetime"
        );
        this.list = res.data;
        // 这里要喊他在列表里加一个staff_uuid 吧 好取一些
        // this.staff_uuid = item.staff_uuid
        // this.staff_uuid = res.data[0].staff_uuid
      }
      this.getTime();
      // console.log(this.limitedTime)
    },
    addProperty_list(val) {
      val.map((item) => {
        item.property_list = [];
        if (Array.isArray(item.children) && item.children.length > 0) {
          this.addProperty_list(item.children);
        }
      });
    },
    addDisabledUpdate(val, status) {
      //递归判断状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          let isNo = null;
          if (item.value == "") isNo = false;
          else {
            if (item.data_type == "boolean") {
              if (item.value == 1) isNo = true;
              if (item.value == 0) isNo = false;
            } else {
              isNo = true;
            }
          }
          this.$set(item, "disabled", status);
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.addDisabledUpdate(item.children, !isNo);
          }
        });
      }
    },
    sortBy(props) {
      //数组对象排序  降序
      return (a, b) => {
        return new Date(b[props]).valueOf() - new Date(a[props]).valueOf();
      };
    },
    // 首先第一次循环每一项都是可以填得，后面根据父级是否有有效时间开放
    addDisabled(val, status) {
      //递归判断状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          let isNo = null;
          let arr = item.property_list.filter((item) => {
            //取出小于
            return Date.parse(item.effective_utc_datetime) <= this.date;
          });
          arr.sort(this.sortBy("effective_utc_datetime"));
          if (arr.length <= 0) isNo = false;
          else {
            if (arr[0].data_type == "boolean") {
              if (arr[0].value == 1) isNo = true;
              if (arr[0].value == 0) isNo = false;
            } else {
              isNo = true;
            }
          }
          this.$set(item, "disabled", status);
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.addDisabled(item.children, !isNo);
          }
        });
      }
    },
    itemDisabled(val, status) {
      //递归加状态
      if (Array.isArray(val) && val.length > 0) {
        val.map((item) => {
          item.disabled = status;
          if (item.children > 0) {
            this.itemDisabled(item.children, status);
          }
        });
      }
    },
    success() {
      //获取属性详情 提交
      if (this.$store.state.uuid) {
      } else {
        this.$emit("savesuccess", this.allList);
      }
    },
    async cancel() {
      //上一步
      if (this.$store.state.uuid) {
        await this.getdetail();
        this.$emit("changeReadonly");
        // this.$myConfirm({
        //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        // })
        //   .then((res) => {
        //     this.$router.push({
        //       name: 'staffmanagement',
        //     })
        //   })
        //   .catch((err) => { })
      } else {
        this.$emit("laststep", 1);
      }
    },
    deleteItem(item, index) {
      if (item.uuid) {
        this.$set(this.list, index, { ...item, "~type~": "del" });
      } else {
        this.list.splice(index, 1);
      }
    },
    deleteItemView(item, index) {
      const dd = this.viewList.splice(index, 1);
    },
    saveViewList(item) {},
    async save() {
      //提交
      if (!this.$refs.forms.validate()) return;
      // console.log(this.$refs.forms.validate())
      if (this.$store.state.uuid) {
        // console.log(this.list, this.viewList)
        let mrbase_sys_staff_property = this.$deletefield([
          ...this.list,
          ...this.viewList,
        ]);
        this.loading=true
        const res = await getpropertyupdate(
          this.$deletefield(null, {
            mrbase_sys_staff_property,
            uuid: this.$store.state.uuid,
          })
        ).finally(()=>{this.loading=false});
        if (res.code == 200) {
          this.$Message({ text: this.$t("成功") });
          await this.getdetail();
        }
      }
      this.close();
    },
    close() {
      this.dialog = false;
      this.viewList = [];
    },
    updatePropertyList(val, uuid, list) {
      //修改属性List
      val.map((item) => {
        if (item.staff_property_master_code == uuid) {
          item.property_list = list;
        } else {
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.updatePropertyList(item.children, uuid, list);
          }
        }
      });
    },
    addValue() {
      //添加属性
      this.viewList.unshift({
        effective_utc_datetime: "",
        value: "",
        data_type: this.data_type,
        prompt_name: this.prompt_name,
        staff_property_master_uuid: this.staff_property_master_uuid,
        staff_property_master_code: this.staff_property_master_code,
        staff_uuid: this.staff_uuid,
        org_level_uuid: this.$store.state.currentCompany,
      });
    },
    deleteLanguageCode(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          delete item.language_code;
        });
      }
    },
    getvalueView(val, value = "value") {
      //显示有效的日期
      if (!val) return "";
      if (Array.isArray(val) && val.length <= 0) return "";
      let date = new Date().valueOf();
      let arr = val.filter((item) => {
        return new Date(item.effective_utc_datetime).valueOf() <= date;
      });
      if (Array.isArray(arr) && arr.length <= 0) return "";
      let time = new Date(arr[0].effective_utc_datetime).valueOf();
      let obj = arr[0];
      arr.forEach((item) => {
        if (new Date(item.effective_utc_datetime).valueOf() > time) {
          obj = item;
        }
      });
      return obj[value];
    },
  },
  computed: {
    sys_property_group() {
      return {
        prompt_name: "sys_property_group",
        org_level_uuid: this.$store.state.currentCompany,
      };
    },
  },
  watch: {
    treeList: {
      handler(val) {
        if (val && val.length > 0) {
          this.allList = val;
          this.addDisabledUpdate(this.allList, false); //加禁用属性
        } else {
          this.allList = [];
        }
      },
    },
  },
  filters: {
    getvalue(val) {
      //显示最接近日期
      if (!val) return "";
      if (Array.isArray(val) && val.length <= 0) return "";
      let date = Date.parse(new Date());
      let arr = val.filter((item) => {
        return Date.parse(item.effective_utc_datetime) > date;
      });
      if (arr.length <= 0) return "";
      let time = Date.parse(arr[0].effective_utc_datetime);
      let obj = arr[0];
      arr.forEach((item) => {
        if (Date.parse(item.effective_utc_datetime) < time) {
          obj = item;
        }
      });
      return obj.value;
    },
  },
};
</script>

<style scoped>
.bigbox {
  text-align: left;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rowbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 35vw;
}
/deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
</style>
